export default __webpack_public_path__ + "static/media/888511945530036284.2b94fcac.gif";